import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { saveSlot, getAllSlots } from '../../services/api';

// Fetch all slots
export const fetchAllSlots = createAsyncThunk(
  'slots/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllSlots();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create new slot
export const createSlot = createAsyncThunk(
  'slots/create',
  async (slotData, { rejectWithValue }) => {
    try {
      const response = await saveSlot(slotData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false
};

const slotSlice = createSlice({
  name: 'slots',
  initialState,
  reducers: {
    resetSlotState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch all slots cases
      .addCase(fetchAllSlots.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllSlots.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAllSlots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create slot cases
      .addCase(createSlot.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createSlot.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createSlot.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { resetSlotState } = slotSlice.actions;
export const selectSlotView = (state) => state.slots.data;
export default slotSlice.reducer; 